module.exports = __webpack_public_path__ + "img/singapore.c6be783c.webp";